import { useState } from "react";
import Preloader from "../Preloader";
import Translate from "../../utils/Translate";
import { accessKeys, hasSomeAccess } from "../../utils/userAccess";
import FinalExamUnlockedSelect from "./FinalExamUnlockedSelect";
import { ELearningRegSettings } from "./ELearningRegSettings";
import { Box, IconButton, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { FinalExamLockedTextSetting } from "./FinalExamLockedTextSetting";

export function ELearningSettings() {
  const [isLoading, setIsLoading] = useState(false);
  const isInternalOrSwedish = hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem, accessKeys.englishCompany);

  return (
    <div>
      {isLoading && <Preloader />}

      <div className="stdPage" style={{ display: "flex", justifyContent: "center", marginBottom: "1.5em" }}>
        <div className="stdCard" style={{ maxWidth: "400px" }}>
          <div className="stdCardHeader">
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {Translate.get("FinalTest")}{" "}
              {isInternalOrSwedish && (
                <Tooltip title={Translate.get("FinalExamUnlockedSelectHelp")}>
                  <IconButton>
                    <InfoIcon color="primary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </div>
          <div className="stdCardBody"></div>
          <FinalExamUnlockedSelect setIsLoading={setIsLoading} showLockFromExercise={isInternalOrSwedish} />
        </div>
      </div>

      {isInternalOrSwedish && (
        <div className="stdPage" style={{ display: "flex", justifyContent: "center", marginBottom: "1.5em" }}>
          <div className="stdCard" style={{ maxWidth: "400px" }}>
            <div className="stdCardHeader">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {Translate.get("RegFieldsELearning")}{" "}
                <Tooltip title={Translate.get("ELearningRegFieldsHelp")}>
                  <IconButton>
                    <InfoIcon color="primary" />
                  </IconButton>
                </Tooltip>
              </Box>
            </div>

            <div className="stdCardBody"></div>
            <ELearningRegSettings setIsLoading={setIsLoading} />
          </div>
        </div>
      )}

      {isInternalOrSwedish && (
        <div className="stdPage" style={{ display: "flex", justifyContent: "center", marginBottom: "1.5em" }}>
          <div className="stdCard" style={{ maxWidth: "400px" }}>
            <div className="stdCardHeader">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {Translate.get("FinalExamLockedSettingTitle")}{" "}
                <Tooltip title={Translate.get("FinalExamLockedTextHelp")}>
                  <IconButton>
                    <InfoIcon color="primary" />
                  </IconButton>
                </Tooltip>
              </Box>
            </div>

            <div className="stdCardBody"></div>
            <FinalExamLockedTextSetting setIsLoading={setIsLoading} />
          </div>
        </div>
      )}
    </div>
  );
}
